module.exports = __webpack_public_path__ + "static/media/selected-scheduler-parlour.b60b9e48.svg";